function validateRegistrationStageRoute(to, from, next) {
    const stage = parseInt(to.query.stage);
    const invitationExpiry = to.query.ip_invite;
    const validStages = [1, 2, 3, 4, 5];
    const currentStage = parseInt(localStorage.getItem('currentStage')) || 0;

    if (invitationExpiry) {
        const isInviteExpired = checkInvitationLinkValidity(invitationExpiry, next);
        if (isInviteExpired) return next({ name: 'link-expired' });

        const newQuery = { ...to.query };
        delete newQuery.ip_invite;

        return next({
            name: to.name,
            params: to.params,
            query: newQuery,
            replace: true
        });
    }

    if (currentStage !== 0 && validStages.slice(1).includes(stage) && currentStage !== stage) {
        next({ name: 'access-denied' });
    } else if (!validStages.includes(stage)) {
        next({ name: 'page-not-found' });
    } else {
        next();
    }
}

function checkInvitationLinkValidity(invitationExpiry) {
    try {
        const expiryTimestamp = Number(invitationExpiry);
        const currentTimestamp = Math.floor(Date.now() / 1000);
        return currentTimestamp > expiryTimestamp;
    } catch (error) {
        console.error('Expiry validation error:', error);
        return true; // treat errors as expired/invalid
    }
}

const routes = [{
    path: '/signup',
    name: 'hqzen-signup-root',
    component: () => import('source/pages/root/HQZenSignupPageGroup.vue'),
    meta: {
        title: 'HQZen Signup Root',
        loginRequired: false
    },
    children: [
        {
            path: 'get-started',
            name: 'get-started',
            component: () => import('source/pages/auth/GetStartedPage.vue'),
            meta: {
                title: 'Get Started - HQZen',
                loginRequired: false
            },
        },
        {
            path: 'business/',
            name: 'business-registration',
            component: () => import('source/pages/auth/signup/BusinessSignupPage.vue'),
            meta: {
                title: 'Business Sign Up - HQZen',
                loginRequired: false
            }
        },
        {
            path: 'ai-funnel',
            name: 'ai-signup-funnel',
            component: () => import('source/pages/auth/signup/AISignupFunnelPage.vue'),
            meta: {
                title: 'Sign Up - HQZen',
                loginRequired: false
            }
        },
        {
            path: 'explore',
            name: 'hqzen-explore',
            component: () => import('source/pages/auth/signup/ExploreHQZenPage.vue'),
            meta: {
                title: 'Explore - HQZen',
                loginRequired: false
            }
        }
    ]
}, {
    path: '/signin',
    name: 'signin',
    component: () => import('source/pages/auth/login/HqzenSigninPage.vue'),
    meta: {
        title: 'Sign in - HQZen',
        loginRequired: false
    }
}, {
    path: '/signup/hqzen',
    name: 'hqzen-registration',
    component: () => import('source/pages/auth/signup/HQZenSignUpPage.vue'),
    beforeEnter: validateRegistrationStageRoute,
    meta: {
        title: 'Registration - HQZen',
        loginRequired: false
    }
}, {
    path: '/password-reset',
    name: 'password-reset',
    component: () => import('source/pages/auth/PasswordResetPage.vue'),
    meta: {
        title: 'Recover Your Account - HQZen',
        loginRequired: false
    }
}, {
    path: '/password-change',
    name: 'password-change',
    component: () => import('source/pages/auth/PasswordChangePage.vue'),
    meta: {
        title: 'Change Password - HQZen',
        loginRequired: false
    }
}, {
    path: '/executive-verification',
    name: 'executive-verification',
    component: () => import('source/pages/auth/ExecutivePasswordChangePage.vue'),
    meta: {
        title: 'Set Password - HQZen',
        loginRequired: false
    }
}, {
    path: '/redirect',
    name: 'redirect',
    component: () => import('source/pages/auth/RedirectPage.vue'),
    meta: {
        title: 'Redirect - HQZEN',
        loginRequired: false
    }
}, {
    path: '/access-denied',
    name: 'access-denied',
    component: () => import('source/pages/auth/AccessDeniedPage.vue'),
    meta: {
        title: 'HQZen',
        canDisplayGlobalModals: false
    },
}, {
    path: '/not-found',
    name: 'not-found',
    component: () => import('source/pages/auth/NotFoundPage.vue'),
    meta: {
        title: 'HQZen',
        canDisplayGlobalModals: false
    },
}, {
    path: '/link-expired',
    name: 'link-expired',
    component: () => import('source/pages/auth/LinkExpiredPage.vue'),
    meta: {
        title: 'HQZen',
    },
}];

export default routes;
